module.exports = __webpack_public_path__ + "img/laodonghetong.a9058123.png";